import admiralQuestionsContainingPii from '../Data/Maps/admiralQuestionsContainingPII';
import {
  ComponentsWithoutCustomerInput,
  ComponentTypes,
} from '../Data/Components';
import { isConditionallyActive } from './conditionality';
import { getValueFromComponent } from './components';

export const isAnswerUsableForAiMatching = (components, component) => {
  const componentType = component.component?.type;
  const mappedQuestionId = component.component?.mappedQuestionId;
  const questionText = component.component?.text;

  if (ComponentsWithoutCustomerInput.includes(componentType)) return false;
  if (componentType === ComponentTypes.SUPPLIER_MATCH) return false;
  if (!mappedQuestionId || !questionText) return false;
  if (admiralQuestionsContainingPii.includes(mappedQuestionId)) return false;
  if (!isConditionallyActive(components, component)) return false;

  return true;
};

const getNonPiiAnswers = (components) => {
  const answers = {};

  Object.values(components).forEach((component) => {
    if (!isAnswerUsableForAiMatching(components, component)) return;

    const value = getValueFromComponent(component);
    if (value !== undefined && value !== null && value !== '') {
      answers[component.component.text] = value;
    }
  });

  return answers;
};

export default getNonPiiAnswers;
